import {Injectable} from "@angular/core";
import {contextPath} from "site";
import {Http} from "@angular/http";
import {AircraftSerialNumberFormatRequest} from "./aircraft-serial-number-format-request";
import {Observable} from "rxjs";
import {AircraftSerialNumberFormatResponse} from "./aircraft-serial-number-format-response";
import {AircraftSerialNumberValidateRequest} from "./aircraft-serial-number-validate-request";
import {AircraftSerialNumberValidateResponse} from "./aircraft-serial-number-validate-response";
import {Aircraft} from "./aircraft";

const apiURL = `${contextPath}/api/validation`;
const serialNumberURL = `${apiURL}/aircraft/serialnumber`;

@Injectable()
export class ValidationService {
	constructor(private http: Http) {}

	getAircraftSerialNumberFormatByAircraft(aircraft: Aircraft): Observable<AircraftSerialNumberFormatResponse> {
		return this.http.post(`${serialNumberURL}/format`,
			new AircraftSerialNumberFormatRequest({
				makeId: aircraft.aircraftMakeId,
				modelId: aircraft.aircraftModelId,
				flyDeviceModelId: aircraft.devices.map(device => device.modelID)
			})
		).map(response => AircraftSerialNumberFormatResponse.fromJSON(response.json()));
	}

	validateAircraftSerialNumberByAircraft(aircraft: Aircraft): Observable<AircraftSerialNumberValidateResponse> {
		return this.http.post(`${serialNumberURL}/validate`,
			new AircraftSerialNumberValidateRequest({
				makeId: aircraft.aircraftMakeId,
				modelId: aircraft.aircraftModelId,
				serialNumber: aircraft.serial,
				flyDeviceModelId: aircraft.devices.map(device => device.modelID)
			})
		).map(response => AircraftSerialNumberValidateResponse.fromJSON(response.json()));
	}

	getAircraftSerialNumberFormatByAircraftAndDeviceModelId(aircraft: Aircraft, deviceModelId: number):
		Observable<AircraftSerialNumberFormatResponse> {
		return this.http.post(`${serialNumberURL}/format`,
			new AircraftSerialNumberFormatRequest({
				makeId: aircraft.aircraftMakeId,
				modelId: aircraft.aircraftModelId,
				flyDeviceModelId: aircraft.devices.map(d => { return d.modelID }).concat(deviceModelId)
			})
		).map(response => AircraftSerialNumberFormatResponse.fromJSON(response.json()));
	}

	validateAircraftSerialNumberByAircraftAndDeviceModelId(aircraft: Aircraft, deviceModelId: number):
		Observable<AircraftSerialNumberValidateResponse> {
		return this.http.post(`${serialNumberURL}/validate`,
			new AircraftSerialNumberValidateRequest({
				makeId: aircraft.aircraftMakeId,
				modelId: aircraft.aircraftModelId,
				serialNumber: aircraft.serial,
				flyDeviceModelId: aircraft.devices.map(d => { return d.modelID }).concat(deviceModelId)
			})
		).map(response => AircraftSerialNumberValidateResponse.fromJSON(response.json()));
	}

	getAircraftSerialNumberFormat(request: AircraftSerialNumberFormatRequest): Observable<AircraftSerialNumberFormatResponse> {
		return this.http.post(`${serialNumberURL}/format`, request)
			.map(response => AircraftSerialNumberFormatResponse.fromJSON(response.json()));
	}

	validateAircraftSerialNumber(request: AircraftSerialNumberValidateRequest): Observable<AircraftSerialNumberValidateResponse> {
		return this.http.post(`${serialNumberURL}/validate`, request)
			.map(response => AircraftSerialNumberValidateResponse.fromJSON(response.json()));
	}
}
